"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VersionsDiffChecker = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactQuery = require("react-query");

var _VersionsWrapper = _interopRequireDefault(require("./VersionsWrapper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var queryClient = new _reactQuery.QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

var VersionsDiffChecker = function VersionsDiffChecker(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement(_reactQuery.QueryClientProvider, {
      client: queryClient
    },
    /*#__PURE__*/
    _react["default"].createElement(_VersionsWrapper["default"], props))
  );
};

exports.VersionsDiffChecker = VersionsDiffChecker;